import {
    Box,
    Grid,
    IconButton,
    Stack,
    Tab,
    Tabs,
    Tooltip,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextareaAutosize,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@mui/material";
  import { DataGrid } from "@mui/x-data-grid";
  import { useSelector } from "react-redux";
  import format from "date-fns/format";
  import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
  import { AgedDebtDueAPI, AgedDebtDueManagementAPI } from "../../Services/api";
  import { useEffect, useState, useRef } from "react";
  import instance from "../../redux/api";
  import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
  import { CommonButton } from "../common/commonButton";
  import { numberFormatter } from "../../utils/generalFunctions";
  import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
  import "../../assets/scss/common.scss";
  import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
  import dayjs from "dayjs";
  import { toast } from "react-toastify";
  import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
  import FilterListIcon from "@mui/icons-material/FilterList";
  import DownloadIcon from "@mui/icons-material/DownloadOutlined";
  import { commonToast } from "../common";
  import CustomDateRangePicker from "../common/CustomDateRangePicker";
  import "../common/commonPageStyles.css";

  export const AgedDebtDueView = () => {
    const toggle = useSelector((state) => state.toggleSideMenu);
    const { userData } = useSelector((state) => state?.user);
    const [searchFieldsPrams, setSearchFieldsPrams] = useState({
      Broker: [],
      lob: "",
      yoa: [],
      policy_ref: "",
      mop_mapped: [],
      market_source: [],
      broker_reference: [],
      insured: [],
      umr: [],
      file_name: "",
      entity: [],
      underwriter: [],
      status_sett: [],
      status_usd: []
    });

    const [tabValue, setTabValue] = useState(1);

    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const [isClearPerformed, setIsClearPerformed] = useState(false);

    //For pagination
    const [paginationCount, setPaginationCount] = useState(0);
    const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
    const [pageState, setPageState] = useState({
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      pageSize: 25,
    });

    //For Date picker
    const [fromInceptionDateValue, setFromInceptionDateValue] = useState("");
    const [toInceptionDateValue, setToInceptionDateValue] = useState("");
    const [fromDueDateValue, setFromDueDateValue] = useState("");
    const [toDueDateValue, setToDueDateValue] = useState("");

    // State to store totals from API response
    const [totals, setTotals] = useState({
      total_prem_due_sett: 0.00,
      total_prem_due_usd: 0.00,
      total_cash_rec_sett: 0.00,
      total_cash_rec_usd: 0.00,
      total_alloc_amt_sett: 0.00,
      total_alloc_amt_usd: 0.00,
      total_cash_unalloc_sett: 0.00,
      total_cash_unalloc_usd: 0.00,
      total_uncollected_prem_sett: 0.00,
      total_uncollected_prem_usd: 0.00,

      total_uncollected_notyet_due_sett: 0.00,
      total_uncollected_notyet_due_usd: 0.00,
      total_uncollected_overdue_sett: 0.00,
      total_uncollected_overdue_usd: 0.00
    });

    const [openCommentsDialog, setOpenCommentsDialog] = useState(null);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [dialogCommentsValue, setDialogCommentsValue] = useState("");
    const [oldConcatenatedComment, setOldConcatenatedComment] = useState("");
    const [commentType, setCommentType] = useState("");
    const [dropdownType, setDropdownType] = useState(""); // Add new state to track dropdown type (action or category)

    // Track original values
    const [originalCCComment, setOriginalCCComment] = useState("");
    const [originalUnderwriterComment, setOriginalUnderwriterComment] = useState("");
    const [originalAction, setOriginalAction] = useState("");
    const [originalCategory, setOriginalCategory] = useState("");

    // Track current values
    const [currentCCComment, setCurrentCCComment] = useState("");
    const [currentUnderwriterComment, setCurrentUnderwriterComment] = useState("");
    const [currentAction, setCurrentAction] = useState("");
    const [currentCategory, setCurrentCategory] = useState("");

    // Track which rows have modified fields
    const [modifiedRows, setModifiedRows] = useState({});

    // Helper function to mark a row as modified and store current values
    const markRowAsModified = (rowId, fieldType, isModified, currentValue = null) => {
      setModifiedRows(prev => {
        // Create a new object to avoid mutation
        const newState = { ...prev };

        // Initialize the row if it doesn't exist
        if (!newState[rowId]) {
          newState[rowId] = {
            cc_comments: { modified: false, value: null },
            underwriter_comments: { modified: false, value: null },
            action: { modified: false, value: null },
            category: { modified: false, value: null }
          };
        }

        // Update the specific field
        newState[rowId][fieldType] = {
          modified: isModified,
          value: currentValue
        };

        // If no fields are modified, remove the row
        if (!Object.values(newState[rowId]).some(field => field.modified)) {
          delete newState[rowId];
        }

        return newState;
      });

      // Also update the current value state variables for easy access
      if (currentValue !== null) {
        switch (fieldType) {
          case 'cc_comments':
            setCurrentCCComment(currentValue);
            break;
          case 'underwriter_comments':
            setCurrentUnderwriterComment(currentValue);
            break;
          case 'action':
            setCurrentAction(currentValue);
            break;
          case 'category':
            setCurrentCategory(currentValue);
            break;
          default:
            break;
        }
      }
    };

    // Track current row data
    const [currentRowData, setCurrentRowData] = useState(null);

    // Safely parse JSON-like strings; return original value if not JSON
    const safeParseJson = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === "string") {
        const text = value.trim();
        // First try standard JSON
        try {
          return JSON.parse(text);
        } catch (_) {
          // Attempt to normalize Python-like repr to JSON
          try {
            const normalized = text
              .replace(/\bNone\b/g, "null")
              .replace(/\bTrue\b/g, "true")
              .replace(/\bFalse\b/g, "false")
              .replace(/'/g, '"');
            return JSON.parse(normalized);
          } catch (_) {
            return value;
          }
        }
      }
      return value;
    };

    // From an input that may be string/obj/array, pick the latest object by "no"
    const getLatestByNo = (input) => {
      const data = safeParseJson(input);
      if (Array.isArray(data)) {
        const items = data.filter((item) => item && typeof item === "object");
        console.log("items", items)
        if (items.length === 0) return null;
        const withNo = items.filter((it) => it?.no !== undefined && it?.no !== null);
        console.log("withNo", withNo)
        if (withNo.length > 0) {
          return withNo.reduce((acc, cur) => (Number(cur.no) > Number(acc.no) ? cur : acc));
        }
        console.log("items[items.length - 1]", items[items.length - 1])
        return items[items.length - 1];
      }
      return data;
    };

    // Get the displayable text from the latest object
    const getLatestValueText = (input) => {
      const latest = getLatestByNo(input);
      if (latest === null || latest === undefined) return "";
      if (typeof latest === "object") {
        return latest.value ?? latest.comment ?? JSON.stringify(latest);
      }
      return latest;
    };

    // skip 0 means page 1
    const currentSkipNumber = () => {
      return pageState?.page === 1
        ? 0
        : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
    };

    useEffect(() => {
      setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
    }, [pageState?.total]);

    const loadData = async () => {
      suppressEffects.current = true;
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));

        let queryParams = `skip=${currentSkipNumber()}&pageSize=${
          pageState?.pageSize
        }`;

        // if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
        // }

        const response = await instance.get(
          `${AgedDebtDueAPI}?due=${tabValue}&${queryParams}`
        );

        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));

        handleVarianceResponse(response);
        setMOPMappedList(response?.data?.mop_mapped);
        setMarketSourceList(response?.data?.market_source);
        setBrokerReferenceList(response?.data?.broker_reference);
        setInsuredList(response?.data?.insured);
        setUmrList(response?.data?.umr);
        setFileNameList(response?.data?.file_name)
        setEntityList(response?.data?.entity)
        setUnderWriterList(response?.data?.underwriter)
        setStatusSettList(response?.data?.status_sett)
        setStatusUSDList(response?.data?.status_usd)
        setIsClearPerformed(false);

        // Default select a file_name from any row if not already selected
        try {
          if (!searchFieldsPrams?.file_name) {
            const defaultFileName = (response?.data?.data || []).find(row => row?.file_name)?.file_name;
            if (defaultFileName) {
              setSearchFieldsPrams(prev => ({ ...prev, file_name: defaultFileName }));
            }
          }
        } catch (_) {
          // no-op
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
        setPaginationCount(0);
        console.error("err", err);
      } finally {
        // Stop suppressing effects
        suppressEffects.current = false;
      }
    };

    const handleClearSearchList = (functionalityType) => {
      if(functionalityType=="Clear"){
        setIsClearPerformed(true);
        setFromInceptionDateValue("");
        setToInceptionDateValue("");
        setFromDueDateValue("");
        setToDueDateValue("");
        setPolicyNumber("");
        // clear fields
        setSearchFieldsPrams(prev => ({
          Broker: [],
          lob: "",
          yoa: [],
          policy_ref: "",
          mop_mapped: [],
          market_source: [],
          broker_reference: [],
          insured: [],
          umr: [],
          // preserve previous file_name value
          file_name: prev.file_name,
          entity: [],
          underwriter: [],
          status_sett: [],
          status_usd: []
        }));
      }
      setIsSearchPerformed(false);
      // Reset page to 1
      setPageState(old => ({
        ...old,
        page: 1
      }));
    };

    const isFilterBtnDisable = () => {
      let disabled = true;
      const { Broker, lob, yoa, policy_ref, mop_mapped, market_source, broker_reference, insured, umr, file_name, entity, underwriter, status_sett, status_usd } = searchFieldsPrams;
      if (
        (Broker && Broker.length > 0) ||
        lob !== "" ||
        (yoa && yoa.length > 0) ||
        policy_ref !== "" ||
        (mop_mapped && mop_mapped.length > 0) ||
        (market_source && market_source.length > 0) ||
        (broker_reference && broker_reference.length > 0) ||
        (insured && insured.length > 0) ||
        (umr && umr.length > 0) ||
        file_name !== "" || 
        (entity && entity.length > 0) ||
        (underwriter && underwriter.length > 0) ||
        (status_sett && status_sett.length > 0) ||
        (status_usd && status_usd.length > 0)
      ) {
        disabled = false;
      }
      return disabled;
    };

    const classes = useStyles();

    const handleVarianceResponse = (response) => {
      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));

        if (response?.data?.summary) {
          setTotals(response.data.summary);
        }

        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    };

    const handleTabChange = async (event, newValue) => {
      handleClearSearchList("tabChange");

      setTabValue(newValue);

      try {
        if (pageState?.page == 1) {
          setPageState((old) => ({
            ...old,
            page: 1,
            pageSize:25,
            isLoading: true,
          }));

          const getSearchQueryParam = searchQueryParams();

          const response = await instance.get(
            `${AgedDebtDueAPI}?due=${newValue}&skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}${getSearchQueryParam}`
          );

          setPageState((old) => ({
            ...old,
            isLoading: false,
          }));

          handleVarianceResponse(response);
        } else {
          setPageState((old) => ({
            ...old,
            page: 1,
            pageSize:25,
            isLoading: true,
          }));
        }
      } catch {
        setPageState((old) => ({
          ...old,
          isLoading: false,
          total: 0,
          data: [],
        }));
      }
    };

    const handleActionRequiredChange = async (rowId, value, reason, type) => {
      if (reason === "blur") {
        return;
      }

      // Store the current row ID
      setCurrentRowId(rowId);

      // Get the row data if not already stored
      if (!currentRowData || currentRowData.id !== rowId) {
        const rowData = pageState.data.find(row => row.id === rowId);
        setCurrentRowData(rowData);

        // Store original values if not already stored
        if (type === "action") {
          const originalValue = rowData?.aged_debt_due_management?.action || "";
          setOriginalAction(originalValue);
          const isModified = value !== originalValue;
          markRowAsModified(rowId, "action", isModified, value);
        } else if (type === "category") {
          const originalValue = rowData?.aged_debt_due_management?.category || "";
          setOriginalCategory(originalValue);
          const isModified = value !== originalValue;
          markRowAsModified(rowId, "category", isModified, value);
        }
      } else {
        // Check if the value has been modified from its original value
        if (type === "action") {
          const isModified = value !== originalAction;
          markRowAsModified(rowId, "action", isModified, value);
        } else if (type === "category") {
          const isModified = value !== originalCategory;
          markRowAsModified(rowId, "category", isModified, value);
        }
      }

      // We're not calling the API yet as per instructions
      // Just tracking the changes for now
    };

    // Function to check if a specific row has any modified fields
    const isRowModified = (rowId) => {
      return modifiedRows[rowId] !== undefined;
    };

    // Function to get the current display value of a field
    const getDisplayValue = (rowId, fieldType, originalValue) => {
      // If the row has been modified and this field has been changed, return the modified value
      if (modifiedRows[rowId] && modifiedRows[rowId][fieldType] && modifiedRows[rowId][fieldType].modified) {
        return modifiedRows[rowId][fieldType].value;
      }
      // Otherwise return the original value
      return originalValue;
    };

    const handleActionButton = async (row) => {
      // Get the current state of all modifiable fields for this row
      const rowModifications = modifiedRows[row.id] || {};

      try {
        // Prepare payload with only modified fields
        const payload = {};
        Object.entries(rowModifications).forEach(([field, data]) => {
          if (data.modified) {
            payload[field] = data.value;
          }
        });

        // Add updated_by to payload
        payload.updated_by = userData?.id;
        payload.agedebt_id = row?.id;
        payload.file_name = row?.file_name;
        payload.status_usd = row?.status_usd;
        payload.installment_due_date = row?.installment_due_date;

        let response;
        if (row?.aged_debt_due_management) {
          // If management record exists, use PATCH
          payload.id = row.id;
          response = await instance.patch(
            `${AgedDebtDueManagementAPI}${row.aged_debt_due_management.id}/`,
            payload
          );
        } else {
          payload.policy_id = row?.policy;
          payload.installment_number = row?.installment_number;
          response = await instance.post(AgedDebtDueManagementAPI, payload);
        }

        if (response?.status === 200 || response?.status === 201) {
          toast.success("Changes saved successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });

          // Refresh the data
          loadData();
        }
      } catch (error) {
        console.error("Error saving changes:", error);
        toast.error("Failed to save changes", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }

      // After saving, reset the modification flags for this row
      setModifiedRows(prev => {
        const newState = { ...prev };
        delete newState[row.id];
        return newState;
      });
    };

    const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
    const handleDownload = async () => {
      setIsDownloadInProgress(true);
      const getSearchQueryParam = searchQueryParams();
      try {
        instance
          .get(`${AgedDebtDueAPI}?download=report${getSearchQueryParam}&due=${tabValue}`, { responseType: "blob" })
          .then((response) => {
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            const fileName = `Aged Report ${format(new Date(), "dd-MM-yyyy")}`;
            link.setAttribute("download", `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setIsDownloadInProgress(false);
            commonToast("success", "File has been downloaded successfully");
          })
          .catch((err) => {
            setIsDownloadInProgress(false);
            commonToast("error", "File could not be downloaded");
          });
      } catch (error) {
        setIsDownloadInProgress(false);
        commonToast("error", "File could not be downloaded");
      }
    };

    const columns = [
      {
        field: "yoa",
        headerName: "YOA",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.yoa,
        renderCell: (params) => (
          <Tooltip title={params?.row?.yoa}>
            <span>{params?.row?.yoa?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "entity_name",
        headerName: "Entity",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.producing_entity,
        renderCell: (params) => (
          <Tooltip title={params?.row?.producing_entity}>
            <span>{params?.row?.producing_entity?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "lob",
        headerName: "LOB",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.policy?.substring(1, 3),
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy?.substring(1, 3)}>
            <span>{params?.row?.policy?.substring(1, 3)?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "market_source",
        headerName: "Market Source",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.market_source,
        renderCell: (params) => (
          <Tooltip title={params?.row?.market_source}>
            <span>{params?.row?.market_source?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "mop",
        headerName: "Mapped MOP",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.mop,
        renderCell: (params) => (
          <Tooltip title={params?.row?.mop}>
            <span>{params?.row?.mop?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "umr",
        headerName: "UMR",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.umr,
        renderCell: (params) => { return params?.row?.umr ?? "-" }
      },
      {
        field: "underwriter",
        headerName: "Underwriter",
        headerAlign: "center",
        width: 160,
        valueGetter: (params) => params?.row?.underwriter,
        renderCell: (params) => (
          <Tooltip title={params?.row?.underwriter}>
            <span>{params?.row?.underwriter?.substr(0, 20) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "master_broker",
        headerName: "Master Broker",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.master_broker,
        renderCell: (params) => (
          <Tooltip title={params?.row?.master_broker}>
            <span>{params?.row?.master_broker?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "broker_branch",
        headerName: "Broker Branch",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.broker_branch,
        renderCell: (params) => (
          <Tooltip title={params?.row?.broker_branch}>
            <span>{params?.row?.broker_branch?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "broker_reference",
        headerName: "Broker Reference",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.broker_reference,
        renderCell: (params) => (
          <Tooltip title={params?.row?.broker_reference}>
            <span>{params?.row?.broker_reference?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "policy",
        headerName: "Policy ref",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.policy,
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy}>
            <span>{params?.row?.policy ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "insured",
        headerName: "Insured",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.insured,
        renderCell: (params) => (
          <Tooltip title={params?.row?.insured}>
            <span>{params?.row?.insured?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "inception_date",
        headerName: "Inception Date",
        headerAlign: "center",
        width: 120,
        renderCell: (params) => (params?.row?.inception_date ? customDateFormat(params.row.inception_date) : "-")
      },
      {
        field: "expired_date",
        headerName: "Expiry Date",
        headerAlign: "center",
        width: 120,
        renderCell: (params) => (params?.row?.expired_date ? customDateFormat(params.row.expired_date) : "-")
      },
      {
        field: "policy_status",
        headerName: "Policy Status",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.policy_status,
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy_status}>
            <span>{params?.row?.policy_status?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "transaction_status",
        headerName: "Transaction Status",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.transaction_status,
        renderCell: (params) => (
          <Tooltip title={params?.row?.transaction_status}>
            <span>{params?.row?.transaction_status?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "bank_name",
        headerName: "Bank Name",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          <Tooltip title={params?.row?.bank_name}>
            <span>{params?.row?.bank_name?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        }
      },
      {
        field: "bank_account_number",
        headerName: "Bank Account Number",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          <Tooltip title={params?.row?.bank_account_number}>
            <span>{params?.row?.bank_account_number?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        }
      },
      // {
      //   field: "claims",
      //   headerName: "Claims",
      //   headerAlign: "center",
      //   width: 100,
      //   valueGetter: (params) => params?.row?.claims,
      //   renderCell: (params) => (
      //     <Tooltip title={params?.row?.claims}>
      //       <span>{params?.row?.claims?.substr(0, 10) ?? "-"}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "installment_due_date",
        headerName: "Due Date",
        headerAlign: "center",
        width: 150,
        renderCell: (params) => {
          try {
            // Check if date exists and is valid
            if (params?.row?.installment_due_date) {
              const date = new Date(params.row.installment_due_date);
              if (!isNaN(date.getTime())) {
                return format(date, "dd-MM-yyyy");
              }
            }
            return "-";
          } catch (error) {
            console.error("Error formatting installment_due_date:", error);
            return "-";
          }
        },
      },
      // {
      //   field: "Aged_Bucket_By_Period_Receivable",
      //   headerName: "Aged",
      //   headerAlign: "center",
      //   width: 120,
      //   valueGetter: (params) => params?.row?.Aged_Bucket_By_Period_Receivable,
      //   renderCell: (params) => (
      //     <Tooltip title={params?.row?.Aged_Bucket_By_Period_Receivable}>
      //       <span>{params?.row?.Aged_Bucket_By_Period_Receivable?.substr(0, 10) ?? "-"}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "original_ccy",
        headerName: "Orig Ccy",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.original_ccy,
        renderCell: (params) => (
          <span>{params?.row?.original_ccy ?? "-"}</span>
        ),
      },
      {
        field: "settlement_ccy",
        headerName: "Sett Ccy",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.settlement_ccy,
        renderCell: (params) => (
          <Tooltip title={params?.row?.settlement_ccy}>
            <span>{params?.row?.settlement_ccy?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "installment_amount_sett",
        headerName: "Total Premium Due Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.installment_amount_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_receivable_sett",
        headerName: "Total Cash Received Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.total_receivable_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_allocated_sett",
        headerName: "Allocated Amount Sett",
        headerAlign: "center",
        width: 180,
        valueGetter: (params) => params?.row?.total_allocated_sett,
        renderCell: (params) => {
          const value = params?.row?.total_allocated_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
      },
      {
        field: "balance_after_subtraction_allocated_sett",
        headerName: "Cash Unallocated Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_allocated_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "balance_after_subtraction_sett",
        headerName: "Uncollected Premium Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ytbp_ageing_sett",
        headerName: "Aged Bucket Sett",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.ytbp_ageing_sett,
        renderCell: (params) => (
          <Tooltip title={params?.row?.ytbp_ageing_sett}>
            <span>{params?.row?.ytbp_ageing_sett?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "installment_amount_usd",
        headerName: "Total Premium Due USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.installment_amount_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_receivable_usd",
        headerName: "Total Cash Received USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.total_receivable_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_allocated_usd",
        headerName: "Allocated Amount USD",
        headerAlign: "center",
        width: 180,
        valueGetter: (params) => params?.row?.total_allocated_usd,
        renderCell: (params) => {
          const value = params?.row?.total_allocated_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
      },
      {
        field: "balance_after_subtraction_allocated_usd",
        headerName: "Cash Unallocated USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_allocated_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "balance_after_subtraction_usd",
        headerName: "Uncollected Premium USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ytbp_ageing_usd",
        headerName: "Aged Bucket USD",
        headerAlign: "center",
        width: 130,
        valueGetter: (params) => params?.row?.ytbp_ageing_usd,
        renderCell: (params) => (
          <Tooltip title={params?.row?.ytbp_ageing_usd}>
            <span>{params?.row?.ytbp_ageing_usd?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "cc_comments",
        headerName: "CC Comments",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div
              onClick={() =>
                handleCommentsOpenDialog(params?.row?.id, params?.row?.aged_debt_due_management?.cc_comments, "cc_comments")
              }
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: 200,
                    gap: 5,
                    // padding: "10px",
                    paddingLeft: "5%"
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      textWrap: "nowrap",
                      // textOverflow: "ellipsis",
                    }}
                  >
                    {(() => {
                      const raw = params?.row?.aged_debt_due_management?.cc_comments;
                      if (typeof raw === "string" && raw?.toLowerCase() === "nan") return "";
                      const display = getLatestValueText(raw);
                      return getDisplayValue(params.row.id, "cc_comments", display ?? "");
                    })()}
                  </div>
                  <MoreHorizIcon />
                </div>
              </div>
            ):
              <div>
                {(() => {
                  const raw = params?.row?.aged_debt_due_management?.cc_comments;
                  const display = getLatestValueText(raw);
                  if (display === null || display === undefined || display === "") return "-";
                  return display;
                })()}
              </div>
            }
          </>
        ),
      },
      {
        field: "action",
        headerName: "Action Required",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => getDisplayValue(
          params.row.id,
          "action",
          params?.row?.aged_debt_due_management?.action || ""
        ),
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div style={{ width: "100%" }}>
                <CommonSelect
                  placeholder="Select Action"
                  value={getDisplayValue(
                    params.row.id,
                    "action",
                    params?.row?.aged_debt_due_management?.action || ""
                  )}
                  handleChange={(event, value, reason) =>
                    handleActionRequiredChange(params.row.id, value, reason, "action")
                  }
                  options={actionList || []}
                  size="small"
                  customStyles={{ minWidth: "100%", fontSize: "0.8rem" }}
                />
              </div>
            ):
              <div>
                {params?.row?.aged_debt_due_management?.action ?? "-"}
              </div>
            }
          </>
        ),
      },
      {
        field: "category",
        headerName: "Category",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => getDisplayValue(
          params.row.id,
          "category",
          params?.row?.aged_debt_due_management?.category || ""
        ),
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div style={{ width: "100%" }}>
                <CommonSelect
                  placeholder="Select Category"
                  value={getDisplayValue(
                    params.row.id,
                    "category",
                    params?.row?.aged_debt_due_management?.category || ""
                  )}
                  handleChange={(event, value, reason) =>
                    handleActionRequiredChange(params.row.id, value, reason, "category")
                  }
                  options={categoryList || []}
                  size="small"
                  customStyles={{ minWidth: "100%", fontSize: "0.8rem" }}
                />
              </div>
            ):
              <div>
                {params?.row?.aged_debt_due_management?.category ?? "-"}
              </div>
            }
          </>
        ),
      },
      {
        field: "underwriter_comments",
        headerName: "Underwriter Comments",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
            <div
              onClick={() =>
                handleCommentsOpenDialog(params?.row?.id, params?.row?.aged_debt_due_management?.underwriter_comments, "underwriter_comments")
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: 200,
                  gap: 5,
                  // padding: "10px",
                  paddingLeft: "5%"
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    textWrap: "nowrap",
                    // textOverflow: "ellipsis",
                  }}
                >
                  {(() => {
                    const raw = params?.row?.aged_debt_due_management?.underwriter_comments;
                    if (typeof raw === "string" && raw?.toLowerCase() === "nan") return "";
                    const display = getLatestValueText(raw);
                    return getDisplayValue(params.row.id, "underwriter_comments", display ?? "");
                  })()}
                </div>
                <MoreHorizIcon />
              </div>
            </div>
            ):
              <div>
                {(() => {
                  const raw = params?.row?.aged_debt_due_management?.underwriter_comments;
                  const display = getLatestValueText(raw);
                  if (display === null || display === undefined || display === "") return "-";
                  return display;
                })()}
              </div>
            }
          </>
        ),
      },
      {
        field: "updated_at",
        headerName: "Updated Date",
        headerAlign: "center",
        width: 175,
        renderCell: (params) => {
          try {
            // Check if date exists and is valid - updated_at is directly on the row, not in aged_debt_due_management
            const dateValue = params?.row?.aged_debt_due_management?.updated_at;
            if (dateValue) {
              const date = customDateFormat(dateValue);
              if (!isNaN(date.getTime())) {
                return format(date, "dd-MM-yyyy");
              }
            }
            return "-";
          } catch (error) {
            console.error("Error formatting updated_at:", error);
            return "-";
          }
        },
      },
      {
        field: "updated_by",
        headerName: "Updated By",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => params?.row?.aged_debt_due_management?.updated_by,
        renderCell: (params) => (
          <Tooltip title={params?.row?.aged_debt_due_management?.updated_by}>
            <span>{params?.row?.aged_debt_due_management?.updated_by ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        flex: 1,
        minWidth: 100,
        description: "This column has a value getter and is not sortable.",
        cellClassName: "actions",
        getActions: ({ row }) => {
          let actionsList = [];
          actionsList.push(
            <CommonButton
                text="Save"
                handleClick={() => handleActionButton(row)}
                hoverColor="#1565c0"
                sx={{
                  backgroundColor: "#1672DE",
                  color: "white",
                }}
                disabled={UserAuthorisation?.["Edit"] !== "Y" || !isRowModified(row.id)}
              />
          );
          return actionsList;
        },
      }
    ]

    const [brokerList, setBrokerList] = useState([]);
    const [lobList, setLOBList] = useState([]);
    const [yoaList, setYOAList] = useState([]);
    const [policyNumber, setPolicyNumber] = useState("");
    const [MOPMappedList, setMOPMappedList] = useState("");
    const [marketSourceList, setMarketSourceList] = useState("");
    const [brokerReferenceList, setBrokerReferenceList] = useState("");
    const [insuredList, setInsuredList] = useState("");
    const [umrList, setUmrList] = useState("");
    const [fileNameList, setFileNameList] = useState("");
    const [entityList, setEntityList] = useState("");
    const [underWriterList, setUnderWriterList] = useState("");
    const [statusSettList, setStatusSettList] = useState("");
    const [statusUSDList, setStatusUSDList] = useState("");
    const [isPolicySearchInProgress, setIsPolicySearchInProgress] = useState(false);
    const [policyOptions, setPolicyOptions] = useState([]);
    const [actionList, setActionList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const suppressEffects = useRef(false);

    const getBrokerList = async () => {
      const response = await instance.get("documents/get_broker_list/");
      setBrokerList(response?.data?.Broker_Name);
    }

    const getLOBList = async () => {
      const response = await instance.get("documents/lob_filter/");
      setLOBList(response?.data?.data);
    }

    const getYOAList = async () => {
      const response = await instance.get("documents/yoa_filter/");
      setYOAList(response?.data?.data);
    }

    const getAgedDebtActionList = async () => {
      const response = await instance.get("documents/aged_debt_action_filter/");
      setActionList(response?.data?.data);
    }

    const getAgedDebtCategoryList = async () => {
      const response = await instance.get("documents/aged_debt_category_filter/");
      setCategoryList(response?.data?.data);
    }

    const getPolicyList = async (inputText) => {
      if (inputText?.length > 2) {
        try {
          setIsPolicySearchInProgress(true);
          const response = await instance.get(
            `documents/policy_line_ref/?policy_line_ref=${inputText}`
          );

          const allPolicies = response.data["all_policies"];
          // Check if the allPolicies array is empty
          setPolicyOptions(allPolicies);
          setIsPolicySearchInProgress(false);
        } catch (error) {
          setIsPolicySearchInProgress(false);
          console.error("Error fetching policies:", error);
        }
      }
    };

    useEffect(() => {
      getBrokerList()
      getLOBList()
      getYOAList()
      getPolicyList()
      getAgedDebtActionList()
      getAgedDebtCategoryList()
    }, [])

    const handleCommentsOpenDialog = (currentRowId, currentRowCommentData, type) => {
      setOpenCommentsDialog(true);
      setCurrentRowId(currentRowId);
      const latestText = getLatestValueText(currentRowCommentData);
      setDialogCommentsValue(getDisplayValue(currentRowId, type, latestText ?? ""));
      // Store the full comment data for displaying old comments
      setOldConcatenatedComment(currentRowCommentData);
      setCommentType(type); // Set the comment type (cc_comments or underwriter_comments)

      // Store the original comment value for comparison
      if (type === "cc_comments") {
        setOriginalCCComment(latestText ?? "");
      } else if (type === "underwriter_comments") {
        setOriginalUnderwriterComment(latestText ?? "");
      }
    };

    const handleCloseDialogs = () => {
      setOpenCommentsDialog(false);
      setDialogCommentsValue("");
      setCurrentRowId(null);
    };

    const handleDialogInputChange = (e) => {
      const newValue = e.target.value;
      setDialogCommentsValue(newValue);
    };

    const handleSaveComments = (value) => {
      // Check if the comment has been modified from its original value
      if (commentType === "cc_comments") {
        const isModified = value !== originalCCComment;
        markRowAsModified(currentRowId, "cc_comments", isModified, value);
      } else if (commentType === "underwriter_comments") {
        const isModified = value !== originalUnderwriterComment;
        markRowAsModified(currentRowId, "underwriter_comments", isModified, value);
      }
      setOpenCommentsDialog(false);

      // Only process if there's a new comment
      if (dialogCommentsValue) {

        // Mark the row as modified
        if (commentType === "cc_comments") {
          markRowAsModified(currentRowId, "cc_comments", true, dialogCommentsValue);
        } else if (commentType === "underwriter_comments") {
          markRowAsModified(currentRowId, "underwriter_comments", true, dialogCommentsValue);
        }

        // Store the updated comment for later use when saving
        if (commentType === "cc_comments") {
          setOriginalCCComment(dialogCommentsValue);
        } else if (commentType === "underwriter_comments") {
          setOriginalUnderwriterComment(dialogCommentsValue);
        }
      }

      handleCloseDialogs();
    };

    const Container = {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 0,
      height: "calc(100vh - 180px)",
      maxHeight: "calc(100vh - 180px)",
      overflow: "hidden",
    };

    const handleCommonDropdown = (name, value, reason, clearKey, hooks, isMulti) => {
      if (reason === "clear") {
        if (hooks && typeof hooks.onClear === "function") hooks.onClear();
        setSearchFieldsPrams(prev => ({ ...prev, [name]: isMulti ? [] : "", [clearKey]: "" }));
      } else {
        if (hooks && typeof hooks.onChange === "function") hooks.onChange(value);
        if (isMulti) {
          // value will be an array of selected items
          setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
        } else {
          setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
        }
      }
    };

    // Single entry point for all filters using name -> clearKey and hooks maps
    const clearKeyFor = {
      Broker: "Broker",
      lob: "lob",
      yoa: "yoa",
      policy_ref: "policy_ref",
      mop_mapped: "mop_mapped",
      market_source: "market_source",
      broker_reference: "broker_reference",
      insured: "insured",
      umr: "umr",
      file_name: "file_name",
      entity: "entity",
      underwriter: "underwriter",
      status_sett: "status_sett",
      status_usd: "status_usd",
    };

    const hooksFor = {
      policy_ref: {
        onClear: () => setPolicyNumber(""),
        onChange: v => setPolicyNumber(v)
      }
    };

    const handleFilterDropdown = (name, value, reason, isMulti = false) => {
      const clearKey = clearKeyFor[name] || name;
      const hooks = hooksFor[name];
      handleCommonDropdown(name, value, reason, clearKey, hooks, isMulti);
    };

    // All specific dropdowns should directly call handleFilterDropdown from UI

    const handleInputChage = (inputValue) => {
      let value = inputValue.toUpperCase().replace(/[^A-Z0-9]/g, "");
      value = value.slice(0, 12);

      if (
        value.charAt(0) !== "P" &&
        value.charAt(0) !== "M" &&
        value.charAt(0) !== "F"
      ) {
        value = value.slice(0, 1);
      }
      setPolicyNumber(value);
      // Keep search params in sync so Search button enables on paste/typing
      setSearchFieldsPrams(prev => ({ ...prev, policy_ref: value }));
      getPolicyList(value);
    };

    const searchQueryParams = () => {
      let getSearchQueryParams = "";
      const { Broker, lob, yoa, policy_ref, mop_mapped, market_source, broker_reference, insured, umr, file_name, entity, underwriter, status_sett, status_usd } = searchFieldsPrams;

      if (Broker.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&Broker=${encodeURIComponent(Broker.join(','))}`
      }

      if (lob) {
        getSearchQueryParams = `${getSearchQueryParams}&lob=${lob}}`
      }

      if (yoa.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&yoa=${encodeURIComponent(yoa.join(','))}`
      }

      if (policy_ref) {
        getSearchQueryParams = `${getSearchQueryParams}&policy_ref=${policy_ref}`
      }

      if (mop_mapped.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&mop_mapped=${encodeURIComponent(mop_mapped.join(','))}`
      }

      if (market_source.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&market_source=${encodeURIComponent(market_source.join(','))}`
      }

      if (broker_reference.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&broker_reference=${encodeURIComponent(broker_reference.join(','))}`
      }

      if (insured.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&insured=${encodeURIComponent(insured.join(','))}`
      }

      if (umr.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&umr=${encodeURIComponent(umr.join(','))}`
      }

      if (file_name) {
        getSearchQueryParams = `${getSearchQueryParams}&file_name=${file_name}`
      }
      
      if (entity.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&entity=${encodeURIComponent(entity.join(','))}`
      }

      if (underwriter.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&underwriter=${encodeURIComponent(underwriter.join(';'))}`
      }

      if (status_sett.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&status_sett=${encodeURIComponent(status_sett.join(','))}`
      }

      if (status_usd.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&status_usd=${encodeURIComponent(status_usd.join(','))}`
      }

      let formattedFromInceptionDateValue = "", formattedToInceptionDateValue = "";

      if (fromInceptionDateValue && toInceptionDateValue) {
        formattedFromInceptionDateValue = format(fromInceptionDateValue, "dd/MM/yyyy");
        formattedToInceptionDateValue = format(toInceptionDateValue, "dd/MM/yyyy");
        getSearchQueryParams = `${getSearchQueryParams}&fromInceptionDate=${formattedFromInceptionDateValue}&toInceptionDate=${formattedToInceptionDateValue}`;
      }

      let formattedFromDueDateValue = "", formattedToDueDateValue = "";

      if (fromDueDateValue && toDueDateValue) {
        formattedFromDueDateValue = format(fromDueDateValue, "dd/MM/yyyy");
        formattedToDueDateValue = format(toDueDateValue, "dd/MM/yyyy");
        getSearchQueryParams = `${getSearchQueryParams}&fromDueDate=${formattedFromDueDateValue}&toDueDate=${formattedToDueDateValue}`;
      }

      return getSearchQueryParams;
    };

    const handleSearchBnkReconciliationList = async () => {
      try {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }

        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        
        const response = await instance.get(
          `${AgedDebtDueAPI}${queryParams}&due=${tabValue}`
        );
        
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));

        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ? response?.data?.data : [],
            page: 1,
          }));
          
          // Update totals from API response
          if (response?.data?.summary) {
            setTotals(response.data.summary);
          }
          
          setIsSearchPerformed(true);
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count ?? 0,
            data: [],
          }));
          setPaginationCount(0);
        }
    } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        console.log("err", err);
      }
    };

    // Effects now check the suppress flag
    useEffect(() => {
      if (suppressEffects.current) return;
      loadData();
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (suppressEffects.current) return;
      if (isClearPerformed) {
        loadData();
      }
    }, [isClearPerformed]);  

    const UserAuthorisation = userData?.user_permissions?.permissions_list['Aged Debt Due'];

    const handleEnter = (e) => {
      if (e.code === "Enter") {
        handleSearchBnkReconciliationList();
      }
      window.scrollBy({
        top: 335,
        behavior: "smooth",
      });
    };

    return (
      <div style={Container}>
        {UserAuthorisation?.["View"] === "Y" ? (
          <Box
            sx={{
              "& .MuiTab-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                },
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
              {/* Filter Sidebar */}
              <CommonFilterSidebar
                isOpen={filterSidebarOpen}
                filterConfigs={[
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Broker Branch
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select Broker"
                          value={searchFieldsPrams?.Broker || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("Broker", value, reason, true)}
                          options={brokerList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          LOB
                        </Typography>
                        <CommonSelect
                          placeholder="Select LOB"
                          value={searchFieldsPrams?.lob || ""}
                          handleChange={(event, value, reason) => handleFilterDropdown("lob", value, reason)}
                          options={lobList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          YOA
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select YOA"
                          value={searchFieldsPrams?.yoa || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("yoa", value, reason, true)}
                          options={yoaList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Policy Ref
                        </Typography>
                        <CommonSelect
                          placeholder="Select Policy Ref"
                          handleChange={(event, value, reason) => handleFilterDropdown("policy_ref", value, reason)}
                          handleInputChage={(value) => handleInputChage(value)}
                          options={policyOptions?.map((option) => option?.policy_id)}
                          value={policyNumber}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Mapped MOP
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select MOP Mapped"
                          value={searchFieldsPrams?.mop_mapped || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("mop_mapped", value, reason, true)}
                          options={MOPMappedList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Market Source
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select Market Source"
                          value={searchFieldsPrams?.market_source || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("market_source", value, reason, true)}
                          options={marketSourceList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Broker Reference
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select Broker Reference"
                          value={searchFieldsPrams?.broker_reference || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("broker_reference", value, reason, true)}
                          options={brokerReferenceList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Insured
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select Insured"
                          value={searchFieldsPrams?.insured || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("insured", value, reason, true)}
                          options={insuredList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          UMR
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select UMR"
                          value={searchFieldsPrams?.umr || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("umr", value, reason, true)}
                          options={umrList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          File Name
                        </Typography>
                        <CommonSelect
                          placeholder="Select file name"
                          value={searchFieldsPrams?.file_name ?? ""}
                          handleChange={(event, value, reason) => handleFilterDropdown("file_name", value, reason)}
                          options={fileNameList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Entity
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select Entity"
                          value={searchFieldsPrams?.entity || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("entity", value, reason, true)}
                          options={entityList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Underwriter
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select underwriter"
                          value={searchFieldsPrams?.underwriter || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("underwriter", value, reason, true)}
                          options={underWriterList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Status Sett
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select status_sett"
                          value={searchFieldsPrams?.status_sett || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("status_sett", value, reason, true)}
                          options={statusSettList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "custom",
                    content: (
                      <>
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#000",
                            marginBottom: "12px",
                          }}
                        >
                          Status USD
                        </Typography>
                        <CommonSelect
                          multiple={true}
                          placeholder="Select status_usd"
                          value={searchFieldsPrams?.status_usd || []}
                          handleChange={(event, value, reason) => handleFilterDropdown("status_usd", value, reason, true)}
                          options={statusUSDList || []}
                        />
                      </>
                    ),
                  },
                  {
                    type: "dateRange",
                    label: "Inception Date",
                    startDate: fromInceptionDateValue,
                    setStartDate: setFromInceptionDateValue,
                    endDate: toInceptionDateValue,
                    setEndDate: setToInceptionDateValue,
                    maxDate: new Date(),
                    onKeyUp: handleEnter,
                  },
                  {
                    type: "dateRange",
                    label: "Due Date",
                    startDate: fromDueDateValue,
                    setStartDate: setFromDueDateValue,
                    endDate: toDueDateValue,
                    setEndDate: setToDueDateValue,
                    onKeyUp: handleEnter,
                  },
                ]}
                onApplyFilters={handleSearchBnkReconciliationList}
                onClearFilters={() => handleClearSearchList("Clear")}
                isLoading={pageState?.isLoading}
                isFilterDisabled={isFilterBtnDisable()}
              />

              {/* Main Content Area */}
              <Box className="main-content-area">
                {/* Top Row: Heading Section and Summary Table side by side */}
                <Box sx={{ display: "flex", gap: "20px", mb: 2, alignItems: "flex-start" }}>
                  {/* Left: Heading Section */}
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", minWidth: "300px" }}>
                    <Typography
                      variant="h5"
                      className="page-heading"
                      sx={{
                        color: "#1672DE",
                        fontSize: "24px",
                        fontWeight: "600",
                      }}
                    >
                      Aged Report
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Selected File Name: <span style={{ color: "#1672DE", fontWeight: "600" }}>{searchFieldsPrams?.file_name || "None"}</span>
                    </Typography>
                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <CommonButton
                        text={isDownloadInProgress ? "Downloading..." : "Download"}
                        hoverColor="#1672DE"
                        icon={<DownloadIcon />}
                        handleClick={handleDownload}
                        disabled={isDownloadInProgress || pageState?.data?.length === 0 || pageState?.isLoading}
                        style={{
                          backgroundColor: "#1672DE",
                          color: "white",
                          borderRadius: "6px",
                          padding: "8px 16px",
                        }}
                      />
                    </Box>
                    <Tabs
                      value={tabValue}
                      onChange={handleTabChange}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "6px",
                        minHeight: "36px",
                        width: "fit-content",
                        "& .MuiTabs-indicator": {
                          display: "none",
                        },
                        "& .MuiTabs-flexContainer": {
                          width: "fit-content",
                        },
                      }}
                      aria-label="aged debt tabs"
                    >
                      <Tab
                        label="Show All"
                        sx={{
                          borderRight: "1px solid #e0e0e0",
                          backgroundColor: tabValue === 0 ? "#1672DE !important" : "transparent !important",
                          color: tabValue === 0 ? "white !important" : "#666 !important",
                          borderRadius: "6px 0 0 6px",
                          minHeight: "36px",
                          minWidth: "100px",
                          maxWidth: "100px",
                          padding: "6px 16px",
                          textTransform: "none",
                          fontWeight: tabValue === 0 ? "600" : "400",
                          "&:hover": {
                            backgroundColor: tabValue === 0 ? "#0d5ba3 !important" : "rgba(22, 114, 222, 0.05) !important",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#1672DE !important",
                            color: "white !important",
                          },
                        }}
                      />
                      <Tab
                        label="Due"
                        sx={{
                          backgroundColor: tabValue === 1 ? "#1672DE !important" : "transparent !important",
                          color: tabValue === 1 ? "white !important" : "#666 !important",
                          borderRadius: "0 6px 6px 0",
                          minHeight: "36px",
                          minWidth: "100px",
                          maxWidth: "100px",
                          padding: "6px 16px",
                          textTransform: "none",
                          fontWeight: tabValue === 1 ? "600" : "400",
                          "&:hover": {
                            backgroundColor: tabValue === 1 ? "#0d5ba3 !important" : "rgba(22, 114, 222, 0.05) !important",
                          },
                          "&.Mui-selected": {
                            backgroundColor: "#1672DE !important",
                            color: "white !important",
                          },
                        }}
                      />
                    </Tabs>
                  </Box>

                  {/* Right: Summary Table - Side by side with heading */}
                  <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <Box sx={{ 
                      p: 0, 
                      backgroundColor: "#ffffff", 
                      borderRadius: "12px", 
                      width: "100%",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                      overflow: "hidden",
                    }}>
                      <Table aria-label="summary table" sx={{ 
                        width: "100%", 
                        borderCollapse: "collapse",
                        "& .MuiTableCell-root": {
                          border: "none",
                        }
                      }}>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px",
                              "&:first-of-type": {
                                borderTopLeftRadius: "12px",
                              },
                            }} align="center">
                              Total
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px"
                            }} align="center">
                              Prem Due
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px"
                            }} align="center">
                              Cash Rec
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px"
                            }} align="center">
                              Alloc
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px"
                            }} align="center">
                              Unalloc
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px", 
                              backgroundColor: "#1672DE", 
                              color: "#ffffff",
                              fontWeight: "600",
                              fontSize: "14px",
                              "&:last-of-type": {
                                borderTopRightRadius: "12px",
                              }
                            }} align="center">
                              Uncollected
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "600"
                            }} align="center">
                              Sett
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_prem_due_sett)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_cash_rec_sett)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_alloc_amt_sett)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_cash_unalloc_sett)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#ffffff",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_uncollected_prem_sett)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "600"
                            }} align="center">
                              USD
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_prem_due_usd)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_cash_rec_usd)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_alloc_amt_usd)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_cash_unalloc_usd)}
                            </TableCell>
                            <TableCell sx={{ 
                              border: "none", 
                              padding: "12px 16px",
                              backgroundColor: "#fafafa",
                              fontSize: "14px",
                              fontWeight: "500"
                            }} align="center">
                              {numberFormatter(totals.total_uncollected_prem_usd)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  </Box>

                  {/* Filter Toggle Button */}
                  <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <IconButton
                      onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                      className="filter-toggle-button"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Box>
                </Box>

                {/* DataGrid - Full width below */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    position: "relative",
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                    overflow: "visible",
                    transition: "all 0.3s ease",
                    border: "1px solid #e8eaf0",
                    paddingBottom: "10px",
                    "&:hover": {
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <DataGrid
                    className={classes.pagination}
                    loading={pageState?.isLoading}
                    rows={pageState?.data ?? []}
                    columns={columns}
                    rowCount={pageState?.total}
                    keepNonExistentRowsSelected
                    disableSelectionOnClick
                    pagination
                    paginationMode="server"
                    page={pageState.page - 1}
                    pageSize={pageState?.pageSize ?? 25}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onPageSizeChange={(newPageSize) => {
                      return setPageState((old) => {
                        setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
                        return { ...old, pageSize: newPageSize, page: 1 };
                      });
                    }}
                    sx={{
                      border: "none",
                      flex: 1,
                      minHeight: 0,
                      "& .MuiDataGrid-root": {
                        border: "none",
                        height: "100%",
                      },
                      "& .MuiDataGrid-main": {
                        height: "100%",
                        "&::-webkit-scrollbar": {
                          width: "8px",
                          height: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#1672DE",
                          borderRadius: "10px",
                          "&:hover": {
                            background: "#0d5ba3",
                          },
                        },
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#f8f9fa",
                        borderBottom: "2px solid #e0e0e0",
                        minHeight: "52px !important",
                        maxHeight: "52px !important",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "transparent",
                        fontWeight: "600",
                        color: "#1672DE",
                        fontSize: "14px",
                        padding: "12px 16px",
                        borderBottom: "none",
                        overflow: "visible",
                        "&:focus": {
                          outline: "none",
                        },
                        "&:focus-within": {
                          outline: "none",
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                          fontWeight: "600",
                          fontSize: "14px",
                          overflow: "visible",
                          textOverflow: "clip",
                          whiteSpace: "normal",
                          lineHeight: "1.4",
                          width: "100%",
                        },
                        "& .MuiDataGrid-sortIcon": {
                          color: "#1672DE",
                        },
                        "& .MuiDataGrid-menuIcon": {
                          color: "#1672DE",
                        },
                      },
                      "& .MuiDataGrid-row": {
                        transition: "all 0.2s ease",
                        borderBottom: "1px solid #f0f0f0",
                        "&:hover": {
                          backgroundColor: "rgba(22, 114, 222, 0.04)",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "rgba(22, 114, 222, 0.08)",
                          "&:hover": {
                            backgroundColor: "rgba(22, 114, 222, 0.12)",
                          },
                        },
                        "&:nth-of-type(even)": {
                          backgroundColor: "#fafafa",
                          "&:hover": {
                            backgroundColor: "rgba(22, 114, 222, 0.04)",
                          },
                        },
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "1px solid #f0f0f0",
                        padding: "12px 16px",
                        fontSize: "13px",
                        color: "#333",
                        display: "flex",
                        alignItems: "center",
                        "&:focus": {
                          outline: "none",
                        },
                        "&:focus-within": {
                          outline: "none",
                        },
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        "&::-webkit-scrollbar": {
                          width: "8px",
                          height: "8px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#1672DE",
                          borderRadius: "10px",
                          "&:hover": {
                            background: "#0d5ba3",
                          },
                        },
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "2px solid #e0e0e0",
                        backgroundColor: "#f8f9fa",
                        minHeight: "48px",
                        maxHeight: "48px",
                        paddingBottom: "8px",
                        paddingTop: "8px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        position: "relative",
                        zIndex: 1,
                      },
                      "& .MuiDataGrid-loadingOverlay": {
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                      },
                    }}
                  />
                  <Stack
                    sx={{
                      position: "absolute",
                      bottom: "16px",
                      right: "20px",
                      zIndex: 10,
                      backgroundColor: "#f8f9fa",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <CommonPaginationContainer
                      count={paginationCount + 1}
                      pageState={pageState}
                      setPageState={setPageState}
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
          </Box>
        )
        : <div style={{paddingTop: "35%", textAlign: "center"}}>You are not authorized to view this page.</div>
      }
      <Dialog open={openCommentsDialog} onClose={handleCloseDialogs}>
        <DialogTitle>
          {commentType === "cc_comments" ? "CC Comment" : "Underwriter Comment"}
        </DialogTitle>
        <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogCommentsValue}
            onChange={handleDialogInputChange}
            className=""
            style={{ width: "350px", minWidth: "350px" }}
            // disabled={currentCommentsIndex!=selectedRowIndex}
          />
          {oldConcatenatedComment && (
            <div
              style={{
                textWrap: "wrap",
                backgroundColor: "rgb(175, 171, 170)",
                marginTop: "10px",
                padding: "20px",
                borderRadius: "5px",
                whiteSpace: "pre-wrap",
                textAlign: "left",
                maxHeight:"300px",
                overflowY:"scroll",
                maxWidth:"400px"
              }}
            >
              {(() => {
                const commentsData = safeParseJson(oldConcatenatedComment);
                if (Array.isArray(commentsData)) {
                  return commentsData.map((comment, index) => (
                    <div key={index} style={{ marginBottom: "10px", borderBottom: "1px solid #ccc", paddingBottom: "8px" }}>
                      <div style={{ marginBottom: "4px" }}>
                        <strong>Value:</strong> {String(comment.value || "")}
                      </div>
                      <div style={{ marginBottom: "4px" }}>
                        <strong>Date:</strong> {String(comment.date || "")}
                      </div>
                      <div>
                        <strong>By:</strong> {String(comment.by || "")}
                      </div>
                    </div>
                  ));
                }
                return String(oldConcatenatedComment || "");
              })()}
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <CommonButton
            text="Cancel"
            handleClick={handleCloseDialogs}
            sx={{
              backgroundColor: "#ffff",
              color: "#000000",
              border: "1px solid #BCBDBF",
            }}
          />
          <CommonButton
            text="Ok"
            handleClick={(e) => {
              const textarea = e.target.closest('.MuiDialog-root').querySelector('textarea');
              handleSaveComments(textarea?.value);
            }}
            hoverColor="#1672DE"
            disabled={!dialogCommentsValue}
          />
        </DialogActions>
      </Dialog>
      </div>
    );
  };
